<template>
  <el-row class="data full">
    <span
      class="dob-title"
    >
      {{ $t('components.loginForm.title') }}
    </span>
    <el-form-item
      :label="$t('common.labels.dob')"
      prop="dob"
      :class="[{'focus': dob}, {'error': !validDate}, 'is-required', 'date']"
    >
      <el-input
        placeholder="mm/dd/yyyy"
        v-model="dob"
        type="text"
        v-mask="'##/##/####'"
        :readonly="patient !== null"
        @keyup.enter.native="submit"
      />
      <span
        v-if="!validDate"
      >
        {{ $t('components.loginForm.errors.date') }}
      </span>
    </el-form-item>
  </el-row>
</template>

<script>
export default {
  name: 'LoginForm',
  data: () => ({
    readonly: false,
    validDate: true,
    patient: null,
    dob: '',
    minAge: 16,
    maxAge: 84,
    maxDaysMonth: ['4', '6', '9', '11'],
  }),
  watch: {
    dob: function (value) {
      this.$emit('update:dob', value);
    }
  },
  methods: {
    submit(){
      this.$emit('sendData');
    },
    checkDate(value) {
      return this.validDate = this.validateDate(value);
    },
    validateDate(date) {
      let splitDate = date.match(/^(\d{2})(\/)(\d{2})(\/)(\d{4})$/),
          month = splitDate ? splitDate[1] : '',
          day = splitDate ?  splitDate[3] : '',
          year = splitDate ? splitDate[5] : '',
          now = new Date().getFullYear(),
          startYear = now - this.minAge,
          endYear = startYear - this.maxAge;

      if ((month < 1 || month > 12) || (day < 1 || day > 31) || (this.maxDaysMonth.includes(month) && day == 31) || (year < endYear || year > startYear)) {
        return false;
      } else if (month == 2) {
        let isleap = (year % 4 == 0 && (year % 100 != 0 || year % 400 == 0));
        if (day > 29 || (day == 29 && !isleap)) {
          return false;
        }
      }
      return true;
    },
  }
};
</script>
